module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "epa-other--cover.7a0fc72c.jpg";